// extracted by mini-css-extract-plugin
var _1 = "QnbIU";
var _2 = "KUz1i";
var _3 = "NWOp7";
var _4 = "l9mj4";
var _5 = "dkOJz";
var _6 = "uXFrp";
export { _1 as "base", _2 as "configurationDetails", _3 as "list", _4 as "slackButton", _5 as "slackIcon", _6 as "title" }
